import { Component, OnInit } from '@angular/core';
import { AspLoadingService } from '../asp-loading/asp-loading.service';
import { MyJobCardsDetailsService } from '../my-job-cards-details/my-job-cards-details.service';
import { BreakpointObserver, Breakpoints } from '@angular/cdk/layout';
import { AspMyItemListService } from '../asp-my-item-list/asp-my-item-list.service';
import { Router } from '@angular/router';
import { ToastrService } from 'ngx-toastr';
interface SuggestionValue {
  name: string;
  id: number;
}

@Component({
  selector: 'app-asp-my-wish-list',
  templateUrl: './asp-my-wish-list.component.html',
  styleUrls: ['./asp-my-wish-list.component.scss']
})
export class AspMyWishListComponent implements OnInit {
  isVisible: boolean;
  vehicleData: any;
  wishlistItems: any;
  itemList: any;
  fevList: any[];
  fevCount: number;
  sparesDiscount: number;
  isMobile: boolean;
  emptyImg:any = 'assets/images/no-cart.png'; 
  isPopupOpen: boolean;
  successIcon: string = '../../../../assets/icons/icons8-ok.gif';
  requestId: any;
  requestCreated: any;
  suggestionMap: any;

  constructor(
     private aspLoadingService: AspLoadingService,
     private myJobCardsDetailsService: MyJobCardsDetailsService,
     private breakpointObserver: BreakpointObserver,
     private aspMyItemListService:AspMyItemListService,
      private router: Router,
       public toastr: ToastrService,
  ) {
    this.breakpointObserver.observe([Breakpoints.Handset])
        .subscribe(result => {
          this.isMobile = result.matches;
        }); 
   }

  ngOnInit(): void {
    this.vehicleData = JSON.parse(localStorage.getItem('vehicleData'));
    if(localStorage.getItem('addAllItem')=='true'){
    this.getItemList();
  }else{
    this.wishItem();
  }
   
  }
  wishItem(){
     const storedMap = sessionStorage.getItem("suggestionMap");
  this.suggestionMap = storedMap ? JSON.parse(storedMap) : {};
      console.log("vehicleData",this.vehicleData);
    const items = sessionStorage.getItem('wishlist');
    if (items) {
      this.wishlistItems = JSON.parse(items);  // Parse the JSON string to an array
    }
  }
  closeSidebar(ishide: boolean) {
    this.isVisible = ishide;
  }
  increaseQty(item: any): void {
    const name = item.name.trim();
    let wishlist: { name: string, quantity: number }[] = JSON.parse(sessionStorage.getItem('wishlist') || '[]');
  
    const existingItem = wishlist.find(w => w.name.toLowerCase() === name.toLowerCase());
  
    if (existingItem) {
      existingItem.quantity += 1;
    } else {
      wishlist.push({ name, quantity: 1 });
    }
  
    sessionStorage.setItem('wishlist', JSON.stringify(wishlist));
    // this.updateWishlistCount();
  }
  
  decreaseQty(item: any): void {
    const name = item.name.trim();
    let wishlist: { name: string, quantity: number }[] = JSON.parse(sessionStorage.getItem('wishlist') || '[]');
  
    const index = wishlist.findIndex(w => w.name.toLowerCase() === name.toLowerCase());
  
    if (index > -1) {
      // Decrease the quantity first
      wishlist[index].quantity -= 1;
      item.quantity = wishlist[index].quantity; // Update UI
  
      if (wishlist[index].quantity <= 0) {
        wishlist.splice(index, 1); // Remove item if quantity is 0
        item.inWishlist = false;   // Update UI state
        
      }
  
      sessionStorage.setItem('wishlist', JSON.stringify(wishlist));
      this.wishItem();
      this.getWishlist();
    }
  }
  
  getItemQuantity(name: string): number {
    const wishlist: { name: string, quantity: number }[] = JSON.parse(sessionStorage.getItem('wishlist') || '[]');
    const existingItem = wishlist.find(w => w.name.toLowerCase() === name.toLowerCase());
    return existingItem ? existingItem.quantity : 1;
  }
  formatText(text: string): string {
    return text
      .split(/[\n,]+/) 
      .map(item => item.trim()) 
      .filter(item => item !== '') 
      .join(',');
  }
  createRequest() {
    this.aspLoadingService.show();
    const items = sessionStorage.getItem('wishlist');
    let quantityMap = new Map<string, number>();
    this.itemList =[];
    const storedMap = sessionStorage.getItem("suggestionMap");
    const suggestionMap = storedMap ? JSON.parse(storedMap) : {};

    if (items) {
      const wishlist = JSON.parse(items);
      wishlist.forEach(item => {
        if (item.name) {
          const cleanKey = item.name.trim().toLowerCase();
         const suggestion = suggestionMap[cleanKey];
        const nameToUse = suggestion?.name ?? item.name;
        quantityMap.set(nameToUse.toUpperCase(), item.quantity);

          this.itemList.push(item.name);
        }
      });
    }

const itemString = this.itemList.join(', ').trim();
    if (!itemString) {
      // this.showError = true;
      this.aspLoadingService.hide();
    } else {
      // this.showError = false;
  
      let formattedItems = this.formatText(itemString);
      this.itemList = formattedItems;
      localStorage.setItem('itemList', JSON.stringify(formattedItems.split(',')));
      console.log("formattedItems",formattedItems);
      const storedMap = sessionStorage.getItem("suggestionMap");
      const suggestionMap: { [key: string]: SuggestionValue } = storedMap ? JSON.parse(storedMap) : {};


      const replaced = formattedItems
        .split(',')
        .map(item => {
          const cleanedKey = item.trim().toLowerCase();
          return suggestionMap[cleanedKey]?.name || item.trim(); // ✅ get only name
        })
        .join(',');


      console.log("Replaced Suggestions:", replaced);
  
      let rowKey = this.vehicleData.rowKey || '';
      let make = this.vehicleData.make || '';
      let model = this.vehicleData.model || '';
      let fuelType = this.vehicleData.fuel || '';
      let vinNumber = this.vehicleData.vin || '';
      let variantKey = this.vehicleData.variantKey || '';
      let variant = this.vehicleData.variant || '';
      let year = this.vehicleData.year || '';
      let registrationNumber = this.vehicleData.registrationNumber || '';
      let notes = replaced || '';
      let partNames = replaced;
      let garageKey = localStorage.getItem('garageKey');
      let jobcardId= '';
      let spareRequestId= '';
      

     const items = Object.entries(suggestionMap).map(([key, value]) => ({
  partType: 'oem',
  itemQuantity: quantityMap.get(value.name.toUpperCase()) ?? 1, // fallback to 1 if not found
  searchKey: value.name,
  itemName: value.name,
  itemDescription: value.name,
  lineItemId: value.id?.toString() ?? '0', // convert id to string, fallback to '0'
  status: '1'
}));


  
      // this.isRquestSidebarOpen = false;
  
      // First Elastic API call
      // this.myJobCardsDetailsService.getPartNameSuggestions(variantKey, partNames).subscribe(
      //   (res: any) => {
          // let itemsArray = res.data || []; // If the API has data inside 'data'
          
          // let items = itemsArray.map((item: any, index: number) => ({
          //   partType: 'oem',
          //   itemQuantity: quantityMap.get(item.searchKey.toUpperCase()),  
          //   searchKey: item.searchKey || encodeURIComponent(item.partName),
          //   itemName: item.partName,
          //   itemDescription: item.searchKey || encodeURIComponent(item.partName),
          //   lineItemId: item.quoteLineItemId?item.quoteLineItemId.toString(): '0',
          //   status: '1',
          // }));

          this.myJobCardsDetailsService.createB2BRequest(rowKey, make, model, fuelType, vinNumber, variantKey, variant, year, registrationNumber, notes, jobcardId, items, spareRequestId).subscribe(
            (res: any) => {
              console.log("res",res)
              if(res?.response?.statusCode==200 && res?.response?.body?.sparerequest?.id){
                this.isPopupOpen = true;
                this.closeSidebar(false);
                sessionStorage.removeItem('wishlist');
                sessionStorage.removeItem("suggestionMap");
                this.getWishlist();
                this.requestId = res?.response?.body?.sparerequest?.id;
                this.requestCreated = res?.response?.body?.sparerequest?.created ? res.response.body.sparerequest.created : '';
                // this.spareRequestRegNo = res?.response?.body?.sparerequest?.regNo ? res.response.body.sparerequest.regNo : '';

                this.myJobCardsDetailsService.setRequestId(garageKey, spareRequestId, jobcardId).subscribe(
                  (res: any) => {
                    if(res?.code==200){

                      // this.isPopupOpen = true;
                      console.log("this.isPopupOpen",this.isPopupOpen)
                      this.aspLoadingService.hide(); 
                    }else{
                      this.aspLoadingService.hide();
                    }
                  },
                  (err) => {
                    // console.error('B2B request API failed', err);
                    this.aspLoadingService.hide();
                  }  
                );
              }else{
                this.aspLoadingService.hide();
              }
            },
            (err) => {
              console.error('B2B request API failed', err);
              this.aspLoadingService.hide();
              this.toastr.error('Spare request already exist. for this Reg No');
            }
          );
        // },
        (err) => {
          console.error('Elastic API Error:', err);
          this.aspLoadingService.hide();
        }
      // );
      
    }
    
  }

  getWishlist(){
    
    this.aspMyItemListService.notifyWishlistChanged();
    if(sessionStorage.getItem('wishlist')){    
      let fevData;  
      this.fevList = [];
      this.fevCount = 0;
      this.sparesDiscount = 0;
      fevData = JSON.parse(sessionStorage.getItem('wishlist'));
      // Object.values(fevData[0]).forEach(fev => { 
      //   this.fevCount += fev['quantity'];
        
      //   this.fevList.push(fev);
      // });
      if (Array.isArray(fevData)) {
        this.fevList = fevData;
        this.fevCount = fevData.length; // Count of unique items only
        console.log("Number of unique items:", this.fevCount);
      }

  console.log("this.fevCount",this.fevCount)
      if(!this.isMobile){
        if(this.fevCount>0 || this.fevCount != undefined){
          (document.getElementsByClassName('autoscore-badge1')[0] as HTMLInputElement).innerHTML = ''+this.fevCount+' items <div class="right-amount-fev">'+'Added to Wishlist'+'</div>';
        }else{
          
          (document.getElementsByClassName('autoscore-badge1')[0] as HTMLInputElement).innerHTML = 'My Wishlist';
        }
      }else{
        if(this.fevCount>0){
          (document.getElementsByClassName('cart_count_mobile')[0] as HTMLInputElement).innerHTML = '<div class="cart_count">'+this.fevCount+'</div>';
        }else{
          (document.getElementsByClassName('cart_count_mobile')[0] as HTMLInputElement).innerHTML = '';
        }
      }
      // this.getShippingCharges()
      // console.log(this.cartList);
      
    }
  }
  closePopup(){
    this.isPopupOpen = false;
    this.closeSidebar(false);
  }
  requestPage(){
    this.router.navigate(['my-request']); 
    this.closePopup()
  }

getSuggestionName(itemName: string): string {
  const key = itemName.trim().toLowerCase(); // 👈 lowercase match
  const suggestion = this.suggestionMap[key];

  return suggestion?.name ?? itemName; // ✅ return name if available, fallback to itemName
}

getItemList(){
  this.aspLoadingService.show(); 
  localStorage.removeItem('addAllItem');
  let searchItems = localStorage.getItem('searchItems');
  let garageKey = localStorage.getItem('garageKey');
  const relevancyCount = 3;
   this.aspMyItemListService
      .getSuggest(relevancyCount, this.vehicleData.variantKey, searchItems, garageKey)
      .subscribe((result) => {
        this.aspLoadingService.hide(); 
      console.log("result",result)
      if (result.code == 200) {
         const suggestionMap: { [key: string]: { name: string; id: number } } = {};

const searchArray = Array.isArray(searchItems) ? searchItems : searchItems.split(',');

searchArray.forEach((rawItem: string) => {
  const item = rawItem.trim().toLowerCase();
  const value = result.details[rawItem.trim()];

  if (value) {
    if (typeof value === 'object' && !Array.isArray(value)) {
      const innerKeys = Object.keys(value);
      const name = innerKeys.length > 0 ? innerKeys[0].trim().replace(/,/g, ' ') : rawItem.trim().replace(/,/g, ' ');
      const id = value[innerKeys[0]];

      suggestionMap[item] = { name, id };
    } else if (Array.isArray(value) && value.length > 0) {
      const firstItem = value[0];
      const name = (firstItem.name?.trim() ?? rawItem.trim()).replace(/,/g, ' ');
      const id = firstItem.id ?? 0;

      suggestionMap[item] = { name, id };
    }
  } else {
    const fallback = rawItem.trim().replace(/,/g, ' ');
    suggestionMap[item] = { name: fallback, id: 0 };
  }
});

sessionStorage.setItem("suggestionMap", JSON.stringify(suggestionMap));

       this.wishItem();
      }
    })
}
}
 